export const GET_CURRENT_USER = "GET_CURRENT_USER"
export const GET_TURN_REMAIN = "GET_TURN_REMAIN"
export const LOGIN_PASSWORD = "LOGIN_PASSWORD"
export const LOGIN_OTP = "LOGIN_OTP"
export const VERIFY_OTP = "VERIFY_OTP"
export const REQUEST_OTP = "REQUEST_OTP"
export const GET_PACKAGE_HISTORY = "GET_PACKAGE_HISTORY"
export const GET_AUCTION_RECORD = "GET_AUCTION_RECORD"
export const VERIFY_OTP_PASSWORD = "VERIFY_OTP_PASSWORD"
export const UPDATE_PASSWORD = "UPDATE_PASSWORD"
export const LOGOUT_USER = "LOGOUT_USER"
export const GET_LIST_PACKAGE = "GET_LIST_PACKAGE"
export const REGISTER_SUB_PACKAGE = "REGISTER_SUB_PACKAGE"
export const REGISTER_RETAIL_PACKAGE = "REGISTER_RETAIL_PACKAGE"
export const UPLOAD_FILE = "UPLOAD_FILE"
export const UPDATE_USER_INFO = "UPDATE_USER_INFO"
export const GET_WINNER_MONTH = "GET_WINNER_MONTH"
export const SET_PU4_NEVER_SHOW = "SET_PU4_NEVER_SHOW"
export const INCREASE_COACH_MARK = "INCREASE_COACH_MARK"
export const UPDATE_INFORMATION_NAME = "UPDATE_INFORMATION_NAME"
export const TOTAL_PIECECOLLECTED = "TOTAL_PIECECOLLECTED"
export const SET_CURRENT_USER = "SET_CURRENT_USER"

